// apps/admin/src/pages/MobileAppPromo.js
// Mobile App Download & Feature Showcase Page for Web Visitors
import React from 'react';
import { Link } from 'react-router-dom';
import './MobileAppPromo.css';

export default function MobileAppPromo() {
  const apkDownloadUrl = '/downloads/ownezzy.apk?v=2.0';
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=${encodeURIComponent('https://admin.ownezzy.com/downloads/ownezzy.apk?v=2.0')}`;

  return (
    <div className="mobile-promo-container">
      <header className="mobile-promo-header">
        <Link to="/admin" className="promo-brand-link">
          <span className="brand-sparkle">✨</span>
          <span className="brand-name">Ownezzy</span>
        </Link>
        <Link to="/admin" className="promo-web-btn">
          Open Web Admin →
        </Link>
      </header>

      <main className="mobile-promo-hero">
        <div className="promo-badge">📱 Official Android Mobile Application</div>
        <h1 className="promo-title">Manage Your Store Anywhere on Android</h1>
        <p className="promo-subtitle">
          Dedicated mobile application for store owners. 0% platform commission, 1-tap WhatsApp notifications, instant inventory toggles, and 100+ demo stores.
        </p>

        <div className="promo-download-card">
          <div className="promo-download-actions">
            <a
              href={apkDownloadUrl}
              download="ownezzy.apk"
              className="promo-apk-btn"
            >
              <span className="btn-icon">⬇️</span>
              <div className="btn-text">
                <span className="btn-title">Download Ownezzy APK</span>
                <span className="btn-sub">Android 8.0+ • Direct Download (v1.0.0)</span>
              </div>
            </a>
            <span className="download-note">Instant install • Safe & verified APK</span>
          </div>

          <div className="promo-qr-box">
            <img src={qrUrl} alt="Scan QR to Download Ownezzy APK" className="promo-qr-img" />
            <span className="promo-qr-label">Scan with your phone to download directly</span>
          </div>
        </div>

        <div className="promo-features-grid">
          <div className="promo-feature-card">
            <span className="feature-icon">💬</span>
            <h3>WhatsApp Order Alerts</h3>
            <p>Receive order alerts directly on your WhatsApp and message buyers with 1 tap.</p>
          </div>
          <div className="promo-feature-card">
            <span className="feature-icon">⚡</span>
            <h3>Instant Stock Toggle</h3>
            <p>Mark items in or out of stock with 1 tap. Changes sync to your storefront in real-time.</p>
          </div>
          <div className="promo-feature-card">
            <span className="feature-icon">💳</span>
            <h3>0% Direct UPI Payments</h3>
            <p>Customers pay directly into your PhonePe/GPay bank account. Zero commission fees.</p>
          </div>
          <div className="promo-feature-card">
            <span className="feature-icon">🏪</span>
            <h3>100+ Ready Demo Stores</h3>
            <p>Launch clothing, bakery, pharmacy, jewelry, and grocery stores in 60 seconds.</p>
          </div>
        </div>
      </main>

      <footer className="mobile-promo-footer">
        <p>© {new Date().getFullYear()} Ownezzy. The all-in-one e-commerce platform for Indian business owners.</p>
        <Link to="/admin" className="footer-link">Back to Admin Panel</Link>
      </footer>
    </div>
  );
}
